export const DrawerLinksPage = (destinationLang) => {
  return [
    {
      FormKey: 'main-menu-drawer-link-complete-profile',
      Key: 'تکمیل اطلاعات',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-drawer-link-upload-on-call-docs',
      Key: 'بارگذاری مدارک',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'general-public-change-password',
      Key: 'تغییر رمز',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-drawer-link-manual-download',
      Key: 'راهنما',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-drawer-link-image-upload',
      Key: 'بارگذاری عکس',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-drawer-link-log-out',
      Key: 'خروج',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-drawer-confirm-message',
      Key: 'آیا از ثبت تغییرات اطمینان دارید؟',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'main-menu-drawer-wallet-button',
      Key: 'کیف پول',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: 'genral-public-label-increase-balance',
      Key: 'مبلغ را به ریال وارد کنید',
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey:
        'genral-public-label-confirm-increase-balance',
      Key: 'آیا از افزایش موجودی اطمینان دارید',
      DistinitationLanguage: destinationLang,
    },
  ];
};
